import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import MDInput from "../../../materialDashboard/components/MDInput";
import {useProvinceQuery, useProvincesInfiniteQuery} from "./query";
import {getScrollHandler, LoadingAdornment} from "../utils";
import {debounce} from "../../../utils/debounce";
import {useTranslation} from "react-i18next";


const ProvinceAutocomplete = ({regionId, MDInputProps={}, value, onChange, disabled, ...props}) => {
    const {t} = useTranslation("inputs");
    const [search, setSearch] = useState("");

    const provincesQuery = useProvincesInfiniteQuery({
        search: search,
        region_id: regionId,
        order_by: "name"
        },
        !disabled
    );
    const provinceQuery = useProvinceQuery(value, {staleTime: Infinity});
    const provinces = provincesQuery.data?.pages?.flatMap((page) => page.items) ?? [];
    const selectedProvince = provinces.find(province => province.id === value) ?? provinceQuery.data;

    const options = [
        ...(selectedProvince ? [selectedProvince] : []),
        ...provinces.filter((s) => !selectedProvince || selectedProvince.id !== s.id),
    ]

    const handleSearchChange = debounce((value) => {
        setSearch(value);
    }, 300);

    return (
        <Autocomplete
            fullWidth
            isOptionEqualToValue={(option, value) => {
                return option.id === value.id
            } }
            options={options}
            filterOptions={(x) => x}
            autoHighlight
            getOptionLabel={(option) => option.name ?? ""}
            onChange={(event, newValue) => onChange(newValue?.id)}
            value={selectedProvince ?? null}
            loading={provinces.isFetching || provinceQuery.isFetching}
            disabled={disabled}
            onClose={() => handleSearchChange("")}
            renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                    <Box key={key} component="li" {...optionProps}>
                        {option.name}
                    </Box>
                );
            }}
            ListboxProps={{onScroll: getScrollHandler(provincesQuery)}}
            renderInput={(params) => (
                <MDInput
                    {...params}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    label={t("provinceAutocomplete.label")}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'off', // disable autocomplete and autofill
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (<LoadingAdornment infiniteQuery={provincesQuery} params={params}/> ),
                    }}
                    variant="standard"
                    {...MDInputProps}
                />
            )}
            {...props}
        />
    );
}

export default ProvinceAutocomplete;